import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useToggle } from "react-use";
import { cn } from "../../utils";
import { Button } from "../elements";
const WithRawValue = props => {
    const { raw, children, className, flipRawValue: flip } = props;
    const [showRaw, toggleShowRaw] = useToggle(false);
    return (_jsxs("div", { className: cn("flex flex-row items-center font-mono text-nowrap", className), children: [!flip || !showRaw ? children : null, !!raw && (!flip || showRaw) && (_jsx("span", { className: cn("text-slate-500 text-sm", { "ml-2": !flip }), children: flip ? `${raw}` : `(${raw})` })), !!flip && (_jsx(Button, { variant: "ghost", size: "sm", className: "ml-1 text-slate-500", onClick: toggleShowRaw, children: showRaw ? "nice" : "raw" }))] }));
};
export default WithRawValue;
